import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import ForwardArrowIcon from '../assets/icons/arrow_forward_24.svg'

const BreadcrumbInHeader = ({ category, currentPage }) => {
  return (
    <div className="flex items-center mb-4 text-sm leading-none text-white lg:mb-8">
      <Link to={`/`} className="inline-block text-white hover:underline">
        Home
      </Link>
      <ForwardArrowIcon className="inline-block w-2 h-2 mx-2 fill-current" />
      {currentPage && (
        <>
          <span className="text-white">{currentPage}</span>
        </>
      )}
    </div>
  )
}

BreadcrumbInHeader.propTypes = {
  category: PropTypes.string,
  currentPage: PropTypes.string,
}

export default BreadcrumbInHeader
